import React from 'react';
import { motion } from 'framer-motion';

const skills = [
  'React',
  'Node.js',
  'Express.js',
  'MongoDB',
  'Python',
  'Django',
  'JavaScript',
  'HTML',
  'CSS',
  'Tailwind CSS',
  'SQL',
  'Pandas',
  'NumPy',
  'GenAI (LangChain, OpenAI API)',
  'Basic ML',
];

const Skills = () => (
  <section className="py-12 bg-black text-white text-center" style={{ fontFamily: 'Outfit, sans-serif' }}>
    <motion.div
      className="max-w-2xl mx-auto px-4"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
    >
      <motion.h2
        className="text-3xl font-bold mb-4 text-green-400"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.2 }}
        viewport={{ once: true }}
      >
        Skills
      </motion.h2>
      <motion.ul
        className="flex flex-wrap justify-center gap-4 text-lg"
        initial="hidden"
        whileInView="visible"
        variants={{ hidden: { opacity: 0 }, visible: { opacity: 1, transition: { staggerChildren: 0.05 } } }}
        viewport={{ once: true }}
      >
        {skills.map((skill, idx) => (
          <motion.li
            key={skill}
            className="bg-gray-800 px-4 py-2 rounded-lg transition transform hover:scale-105 hover:underline cursor-pointer"
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: 0.05 * idx }}
            viewport={{ once: true }}
          >
            {skill}
          </motion.li>
        ))}
      </motion.ul>
    </motion.div>
  </section>
);

export default Skills; 